import React from 'react';
import { HomePage } from './components/HomePage';

const App: React.FC = () => {
  return (
    <HomePage />
  );
};

export default App;